import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useAuthContext } from '../hooks';
import { getLandingPath, isModuleEnabled } from '../../utils/company-modules';

// ----------------------------------------------------------------------

// Gate rotte in base ai flag modulo dell'azienda del dipendente.
// Complementa il gate del menu: qui blocca l'accesso via URL diretto.
// Va usato dentro <AuthGuard>, che ha già risolto l'autenticazione.
export default function ModuleGuard({ flag, children }) {
  const { loading, user } = useAuthContext();

  if (loading) {
    return null;
  }

  if (!isModuleEnabled(user?.data?.company, flag)) {
    return <Navigate to={getLandingPath(user)} replace />;
  }

  return <>{children}</>;
}

ModuleGuard.propTypes = {
  flag: PropTypes.string.isRequired,
  children: PropTypes.node,
};
